import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardLayout, TableLayout } from '../../containers/Layout';
import { TableRow, TableCell, Button, Grid, TableHead, TableFooter, Box, TableBody, Typography, IconButton } from '@material-ui/core';
import SingleBL from '../../reapproIntern/SingleBL';
import Currency from '../../../../../commonModules/Currency';
import { isEmpty } from 'lodash-es';
import { CollectionsBookmark } from '@material-ui/icons';
import { fetchTransferDetails, fetchTransferDetailsTmp } from '../../../../../../../../jsx/actions/transferAction';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';

const SingleTransferReappro = (props) => {
    const dispatch = useDispatch();
	const PRODUCTS = useSelector((state) => state.inventory.products); 
    
    const [trsf, setTrsf] = useState({});
    const [BL, setBL] = useState(false);
    const [local, setLocal] = useState({});
    const [pItem, setPItem] = useState({});
    const [productName, setProductName] = useState("");
    const [nbCol, setNbCol] = useState(7); // 7 colonnes sans TVA (photo, produit, qté, PU HT, Total HT, Total TTC, Ranger)
    // const [matchPurchase, setMatchPurchase] = useState({});

    useEffect(() => {
        // const fetchLocals = async () => {
        //     console.log("[INFO] MOUNTING SALE SINGLE ");
        //     if(props.transfer.received) {
        //         let req = await fetch("/stocks/locals/shop",{
        //             method:"POST",
        //             headers: {
        //                 'Content-Type': 'application/json',
        //             },
        //             body: JSON.stringify({ shopID: props.shopDest.id }),
        //             credentials: 'same-origin',
        //         });
        //         let res = await req.json();
        
        //         console.log("getShopLocal", {res});
        //         if(res.error){
        //             console.log("getShopLocal", res.error.error);
        //         } else {
        //             setLocal(res.id !== "" && res);
        //             // setMatchPurchase(purchase);
        //         }
        //     } 
        // };
        const fetchTransferData = async () => {
            try {
                if (!props.draft){
                    const data = await dispatch(fetchTransferDetails(props.transfer.id));
                    setTrsf(data);
                } else {
                    const data = await dispatch(fetchTransferDetailsTmp(props.transfer.id, 'tmp/draft'));
                    setTrsf(data);

                }

            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
    
        fetchTransferData();
        // fetchLocals();
        if (props.draft){
            setNbCol(3)
        }
    }, [props.shopDest.id, props.transfer.id]);

    const openLocalMap = (pItem, productName) => {
        setPItem(pItem);
        setProductName(productName);
    };

    const createProductList = () => {
        const { shop, draft } = props;

        return !isEmpty(trsf.products) && trsf.products.map(item => {
            let prod = PRODUCTS && PRODUCTS[item.product_id];
            // Utiliser les bonnes propriétés HT et TTC
            const totalHT = parseFloat(item.total_ht || item.price_ht || 0);
            const totalTTC = parseFloat(item.total_ttc || item.price_ttc || item.cost || 0);
            let PU_HT = item.price_u || (totalHT / item.quantity);
            
            return (
                <TableRow key={item.id}>
                    <TableCell className="photo-trsf-single">
                        {prod && prod.photos && prod.photos.length > 0 && prod.photos[0].filename &&
                            <img 
                                id={prod.photos[0].filename} 
                                src={`/stocks/photos/${prod.photos[0].filename}`} 
                            />
                        }
                    </TableCell>
                    <TableCell className="text-left">{prod?.name || `Product ID: ${item.product_id}`}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                    {!draft &&
                        <>
                            <TableCell><Currency value={PU_HT} /></TableCell>
                            <TableCell><Currency value={totalHT} /></TableCell>
                            <TableCell><Currency value={totalTTC} /></TableCell>
                            <TableCell className="no-print">
                                {!isEmpty(local) && item.rest > 0 &&
                                    <IconButton onClick={() => openLocalMap(item, prod?.name || `Product ID: ${item.product_id}`)}> 
                                        <CollectionsBookmark />
                                    </IconButton>
                                }
                            </TableCell>
                        </>
                    }
                </TableRow>
            );
        });
    };

    const getTotal = () => {
        let totalHT = 0;
        let totalTTC = 0;
        !isEmpty(trsf.products) && trsf.products.map(item => {
            const ht = parseFloat(item.total_ht || item.price_ht || 0);
            const ttc = parseFloat(item.total_ttc || item.price_ttc || item.cost || 0);
            totalHT += ht;
            totalTTC += ttc;
        });
        
        return { totalHT, totalTTC };
    };

    let totals = getTotal();
    let totalHT = totals.totalHT;
    let totalTTC = totals.totalTTC;

    // ⚠️ IMPORTANT: Le surcout inclut déjà transport et taxes proportionnellement
    // dans le calcul du TTC de chaque produit (PriceTTC = PriceHT × Surcout)
    // où Surcout = (Transport + Taxes) / Total_HT + 1
    // Donc on ne doit PAS ajouter transport/taxes au totalTTC final
    // if (trsf.taxes) {
    //     totalTTC += trsf.taxes;
    // }
    // if (trsf.transport) {
    //     totalTTC += trsf.transport;
    // }

    return (
        <SingleTransferTemplate
            shop={props.shop}    
            shopDest={props.shopDest}    
            // sale={trsf}   
            transfer={trsf}   
            notif={props.notif} 
            handleBL={() => setBL(!BL)}
            BL={BL}
            BLOpt
            draft={props.draft}
            handleUpdateRea={props.handleUpdate}
        >
            {BL ?
                <SingleBL 
                    PRODUCTS={PRODUCTS}
                    transfer={trsf}
                />
            :
            <>
                {/* <PopUp
                    title={`Rangement ${productName}`}
                    open={!!productName}
                    close={() => setProductName("")}
                    appbar
                >
                    <PreviewLoc
                        {...local}
                        pItem={pItem}
                        productName={productName}
                    />
                </PopUp> */}

                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell className="text-left">Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            {!props.draft &&
                                <>
                                    <TableCell>PU HT</TableCell>
                                    <TableCell>Total HT</TableCell>
                                    <TableCell>Total TTC</TableCell>
                                    <TableCell className="no-print">
                                        {!isEmpty(local) &&
                                            <span className="no-print">Ranger</span>
                                        }
                                    </TableCell>
                                </>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {createProductList()}
                        
                        {!props.draft ?
                        <>
                            <TableRow>
                                <TableCell colSpan={nbCol} />
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={(nbCol-4)} />
                                <TableCell>Sous Total</TableCell>
                                <TableCell><Currency value={totalHT} /></TableCell>
                                <TableCell className="f-700"><Currency value={totals.totalTTC} /></TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={(nbCol-2)}  style={{textAlign: "right", fontStyle: "italic", color: "#666"}} >
                                    Transport (inclus)
                                </TableCell>
                                <TableCell style={{fontStyle: "italic", color: "#666"}}>
                                    <Currency value={(trsf.transport || 0)} />
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={(nbCol-2)}  style={{textAlign: "right", fontStyle: "italic", color: "#666"}} >
                                    Autres Taxes (inclus)
                                </TableCell>
                                <TableCell style={{fontStyle: "italic", color: "#666"}}>
                                    <Currency value={(trsf.taxes || 0)} />
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                        </>
                        :
                        <>
                            <TableRow>
                                <TableCell  />
                                <TableCell style={{textAlign: "right", fontStyle: "italic", color: "#666"}} >
                                    Transport (inclus)
                                </TableCell>
                                <TableCell style={{fontStyle: "italic", color: "#666"}}>
                                    <Currency value={(trsf.transport || 0)} />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell  />
                                <TableCell style={{textAlign: "right", fontStyle: "italic", color: "#666"}} >
                                    Autres Taxes (inclus)
                                </TableCell>
                                <TableCell style={{fontStyle: "italic", color: "#666"}}>
                                    <Currency value={(trsf.taxes || 0)} />
                                </TableCell>
                            </TableRow>
                        </>
                        }
                    </TableBody>   
                    {!props.draft &&
                    <TableFooter> 
                        <TableRow>
                            <TableCell colSpan={(nbCol - 2)} style={{textAlign: "right"}}>
                                <Typography variant="h6">TOTAL</Typography>
                            </TableCell>
                            <TableCell className="f-700">
                                <Typography variant="h6"><b><Currency value={(totalTTC || 0)} /></b></Typography>
                            </TableCell>
                            <TableCell className="no-print"/>
                        </TableRow>
                    </TableFooter>
                    }
                </TableLayout>   
            </>  
            }
        </SingleTransferTemplate>
    );
};

export default SingleTransferReappro;
